function syncProductCountDisplay() {
  const countEl = document.getElementById('ProductCount');
  const grid = document.getElementById('product-grid');

  if (!countEl || !grid || !countEl.dataset.productCountOne) {
    return;
  }

  const count = grid.querySelectorAll('card-product').length;
  const template =
    count === 1
      ? countEl.dataset.productCountOne
      : countEl.dataset.productCountOther;

  countEl.textContent = template.replace(/\d+/, count);
}

window.syncProductCountDisplay = syncProductCountDisplay;

document.addEventListener('DOMContentLoaded', syncProductCountDisplay);
window.addEventListener('shopify:section:load', syncProductCountDisplay);